export default __webpack_public_path__ + "ad63620f8feee7996cbadec32d553e0f.png";